document.addEventListener("DOMContentLoaded", function () {
    const nav = document.querySelector(".main_nav");

    const onScroll = () => {
        if (window.scrollY > 0) {
            nav.classList.add("scrolled");
        } else {
            nav.classList.remove("scrolled");
        }
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
});